import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useLoading } from '../context/LoadingContext';
import { getActiveFetchCount } from '../hooks/fetchTracker';

const useRouteChange = () => {
  const location = useLocation();
  const { showLoading, hideLoading } = useLoading();
  const timeoutRef = useRef(null);
  const previousLocationRef = useRef(location);

  useEffect(() => {
    try {
      window.scrollTo(0, 0);
      // Store the current timeout ref value
      const currentTimeout = timeoutRef.current;

      // Clear any existing timeout
      if (currentTimeout) {
        clearTimeout(currentTimeout);
      }
 
      // Only show loading if the location has changed
      if (location.pathname !== previousLocationRef.current.pathname) {
        //console.log('Location changed, showing loader');
       // showLoading();
      }

      // Update the previous location
      previousLocationRef.current = location;
 
      // Hide loading after a longer delay to ensure content is loaded
      // Check if there are any pending API calls
     // fetchTracker.js (or inside your useRouteChange.js if you prefer)
     let delay = 1000; 
     if(previousLocationRef.current?.pathname?.includes("view")){
      delay = 300000
     }
     if(getActiveFetchCount() === 0){
      timeoutRef.current = setTimeout(() => {
        hideLoading();
      },delay);
     }
       
       
      return () => {
        try {
          if (currentTimeout) {
            clearTimeout(currentTimeout);
          }
          //console.log('Cleanup: hiding loader');
          //hideLoading();
        } catch (error) {
          //console.error('Error in cleanup:', error);
         // hideLoading();
        }
      };
    } catch (error) {
      //console.error('Error in useRouteChange:', error);
      //hideLoading();
    }
  }, [location, showLoading, hideLoading]);
};

export default useRouteChange; 